import React from 'react';
import { CalculationResult } from '../utils/roiCalculations';
import { fmtMoney, fmtPct } from '../utils/formatters';
interface ResultsSummaryProps {
  results: CalculationResult;
}
export function ResultsSummary({
  results
}: ResultsSummaryProps) {
  const roiClass = results.roi >= 0 ? 'text-green-600' : 'text-red-600';
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6" data-id="element-224">
      {/* Hires / Month */}
      <div className="p-4 md:p-6 rounded bg-gray-50 border-2 border-gray-200" data-id="element-225">
        <div className="text-sm text-gray-600 mb-2 font-semibold" data-id="element-226">
          Hires / Month (estimated)
        </div>
        <div className="text-2xl md:text-3xl font-bold text-navy" data-id="element-227">
          {results.hiresPerMonth.toLocaleString()} / mo
        </div>
        <div className="text-sm text-gray-600 mt-2" data-id="element-228">
          Launched: {results.launchedPerMonth.toFixed(1)} / mo
        </div>
      </div>

      {/* Gross Profit */}
      <div className="p-4 md:p-6 rounded bg-gray-50 border-2 border-gray-200" data-id="element-229">
        <div className="text-sm text-gray-600 mb-2 font-semibold" data-id="element-230">
          12-Month Gross Profit
        </div>
        <div className="text-2xl md:text-3xl font-bold text-green-600" data-id="element-231">
          {fmtMoney(results.totalGrossProfit)}
        </div>
        <div className="text-sm text-gray-600 mt-2" data-id="element-232">
          GP / Sale: {fmtMoney(results.gpPerSale)}
        </div>
      </div>

      {/* ROI */}
      <div className="p-4 md:p-6 rounded bg-gray-50 border-2 border-gray-200" data-id="element-233">
        <div className="text-sm text-gray-600 mb-2 font-semibold" data-id="element-234">
          12-Month ROI
        </div>
        <div className={`text-2xl md:text-3xl font-bold ${roiClass}`} data-id="element-235">
          {fmtPct(results.roi)}
        </div>
        <div className="text-sm text-gray-600 mt-2" data-id="element-236">
          Net Profit: {fmtMoney(results.totalNetProfit)}
        </div>
      </div>
    </div>;
}